






































































import { Component, Prop, mixins } from 'nuxt-property-decorator'
import {
  ref,
  defineComponent,
  useStore,
  computed,
  useRoute,
  onMounted,
} from '@nuxtjs/composition-api'
import { SectionCore } from '@/mixins/sectionCore'
import { FormType } from '@/contracts/FormType'
import {
  IFormContactBlock,
  emptyFormContactBlock,
} from '@/contracts/IFormContactBlock'
import SectionBasic from '@/components/SectionBasic.vue'
import BlockForms from '@/components/BlockForms.vue'
import BlockFeedback from '@/components/BlockFeedback.vue'

@Component
class SectionForm extends mixins(SectionCore) {
  @Prop() readonly formType: FormType = FormType.NotSet
  @Prop() readonly contacts: IFormContactBlock = emptyFormContactBlock()
  @Prop() readonly agentPhoneNumber: string = ''
  @Prop() readonly subjectEmailText: string = ''
  @Prop() readonly hideDefault: boolean = false
  @Prop() readonly isNewStyle: boolean = false
  @Prop() readonly bitrixId: number = 0
  @Prop() readonly recipientsBitrixId: number = 0
}

export default defineComponent({
  name: 'SectionForm',
  components: {
    SectionBasic,
    BlockForms,
    BlockFeedback,
  },
  props: SectionForm.options.props,
  setup(props: SectionForm) {
    const { getters } = useStore()
    const route = useRoute()
    const isShowSection = ref(
      !props.hideDefault || route.value.query.form === 'sectionForm'
    )
    const isShowForm = ref(true)
    const isSuccess = ref(true)
    const loading = ref(false)
    const errorMessage = ref('')
    const buttonText = computed(() => getters['settings/btnFormAgain'])
    const { isNewStyle } = props

    const onFormSuccess = (): void => {
      onResetForm('', true)
    }

    const onResetForm = (
      errorResponseMessage: string,
      success: boolean
    ): void => {
      if (errorResponseMessage) {
        errorMessage.value = errorResponseMessage
      } else {
        errorMessage.value = ''
      }

      isSuccess.value = success
      isShowForm.value = !isShowForm.value
      if (success === true) {
        const blockFeedback = document.getElementById(props.formType)
        if (blockFeedback) {
          blockFeedback.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          })
        }
      }
    }

    return {
      isShowSection,
      isShowForm,
      isSuccess,
      onResetForm,
      onFormSuccess,
      buttonText,
      loading,
      errorMessage,
    }
  },
})
